import React from 'react';
import { homeownerDiscountLabel } from '../shared/consentCopy';

/** Logged-in homeowner view of a vendor offer. */
export default function HomeownerDiscount({ vendor, color = '#0f766e' }) {
  if (!vendor || !vendor.discount) return null;
  return (
    <div style={{ marginTop: '0.5rem', color, fontSize: '0.9rem', lineHeight: 1.45 }}>
      <p style={{ margin: 0, fontWeight: 650 }}>{homeownerDiscountLabel(vendor.name)}</p>
      <p style={{ margin: '0.25rem 0 0', whiteSpace: 'pre-wrap' }}>{vendor.discount}</p>
    </div>
  );
}
